import { useQuery } from "@tanstack/react-query";

import { supplierQueryKeys } from "../../shared/query-keys";
import { getIndustries } from "./supplier-registration.api";

export interface IndustryOption {
  /** Raw Dynamics cp_mainindustry option-set value, submitted back to CIM as-is. */
  value: number;
  label: string;
}

// Industry is optional everywhere, so callers must treat a failed load as "no options", never as
// a reason to block the form.
export type GetIndustriesError = 503 | null;

export const useGetIndustries = (): {
  data: IndustryOption[] | undefined;
  isLoading: boolean;
  error: GetIndustriesError;
} => {
  const { data, isLoading, error } = useQuery({
    queryKey: supplierQueryKeys.industries(),
    queryFn: getIndustries,
    retry: false,
  });

  return { data, isLoading, error: error ? 503 : null };
};
